import { motion } from "framer-motion"

interface Props {
  language: "tr" | "en"
  decision: string
  sessionId: string
  onDone: () => void
}

export const OutcomeScreen = ({ language, decision, sessionId, onDone }: Props) => {
  const handleOutcome = async (outcome: "done" | "not_done" | "postponed") => {
    const { supabase } = await import("../lib/supabase")
    await supabase
      .from("sessions")
      .update({ outcome })
      .eq("id", sessionId)
    onDone()
  }

  const t = language === "tr" ? {
    title: "Dün bunu seçtin.",
    question: "Ne oldu?",
    done: "Yaptım",
    not_done: "Yapmadım",
    delayed: "Erteledim",
    skip: "Atla",
  } : {
    title: "Yesterday, you chose this.",
    question: "What happened?",
    done: "Done",
    not_done: "Didn't do it",
    delayed: "Delayed",
    skip: "Skip",
  }

  return (
    <motion.div
      initial={{ opacity: 0, y: 16 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
      className="step-container"
      style={{ flex: "none", textAlign: "center" }}
    >
      <div style={{ fontSize: "13px", fontWeight: "600", letterSpacing: "0.1em", color: "var(--text-muted)", marginBottom: "16px" }}>
        {t.title}
      </div>

      <div style={{
        padding: "18px 20px",
        background: "rgba(123,92,255,0.08)",
        border: "1px solid rgba(123,92,255,0.25)",
        borderRadius: "14px",
        marginBottom: "28px",
        fontSize: "18px",
        fontWeight: "600",
        color: "var(--text-primary)",
        lineHeight: "1.4",
      }}>
        {decision}
      </div>

      <div style={{ fontSize: "15px", color: "var(--text-secondary)", marginBottom: "20px" }}>
        {t.question}
      </div>

      <div style={{ display: "flex", flexDirection: "column", gap: "10px", marginBottom: "20px" }}>
        <button onClick={() => handleOutcome("done")} className="btn-primary">
          {t.done}
        </button>
        <button onClick={() => handleOutcome("not_done")} className="btn-secondary">
          {t.not_done}
        </button>
        <button onClick={() => handleOutcome("postponed")} className="btn-secondary">
          {t.delayed}
        </button>
      </div>

      <button
        onClick={onDone}
        style={{
          background: "none",
          border: "none",
          color: "var(--text-muted)",
          fontSize: "13px",
          cursor: "pointer",
          padding: "4px",
        }}
      >
        {t.skip}
      </button>
    </motion.div>
  )
}